import React from "react"
import Typography from '@react-mdc/typography';

const Projects = () => (
  <Typography.Headline>Projects</Typography.Headline>
)

export default Projects



// WEBPACK FOOTER //
// ./src/pages/projects.js